/**
 * Every word the Look panel shows that its mount does not give it (the title, the footer's words and the note line
 * are the mount's). The row names are ADR-094 decision 24's and the facings and the turn buttons the design card's
 * (`look-step`); the counts beside a row's name follow the card's "Tone 4 of 10". Each is a draft for the author.
 * `{place}` and `{count}` are numbers as the page prints them; `{facing}` is a facing's word as it reads inside
 * that sentence (`figureFacings`), written beside the word the turn row shows (`facings`). `change` is the Change
 * look window's own words: the menu's item, the title with the character's `{name}`, the footer, and its three
 * sentences, the author's, kept as written (2026-10-07).
 */
export const LOOK = {
  rows: {
    skin: "Skin",
    hairStyle: "Hair",
    hairColour: "Hair colour",
    clothesStyle: "Clothes",
    clothesColour: "Clothes colour",
  },
  tone: "Tone {place} of {count}",
  colour: "Colour {place} of {count}",
  swatch: "{row} {place} of {count}",
  turnLeft: "Turn left",
  turnRight: "Turn right",
  facings: {
    down: "Front",
    left: "Left",
    up: "Back",
    right: "Right",
  },
  figureFacings: {
    down: "front",
    left: "left",
    up: "back",
    right: "right",
  },
  figure: "Your character, facing {facing}",
  noFigure: "The preview could not be loaded.",
  change: {
    item: "Change look",
    title: "Change look: {name}",
    cancel: "Cancel",
    randomise: "Randomise",
    confirm: "Confirm",
    saving: "Saving",
    rate: "You have changed your look too often. Try again in a minute.",
    unanswered: "The look could not be changed. Try again.",
    frozen: "A frozen character's look cannot be changed.",
  },
} as const;
